import { Characters } from '../../data/Characters'

module.exports = (opts) => {
  if (opts && opts.pool) return opts
  let include = opts && opts.include ? opts.include : 'ULDBPS'
  let pool = []
  for (const c of include) pool = pool + Characters[c]
  return { pool: pool }
}



// WEBPACK FOOTER //
// ./src/private/scanners/character.js